var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-image",class:_vm.rootClass,style:(_vm.wrapperVars)},[_c('svg-icon',{staticClass:"placeholder-image__icon",style:(_vm.iconVars),attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }